import { RouterModule, Routes } from "@angular/router";
import { AssetManagementAuthoringToolsComponent } from "./auth-tools/asset-management-authoring-tools/asset-management-authoring-tools.component";
import { AssetManagementDashboardComponent } from "./auth-tools/asset-management-dashboard/asset-management-dashboard.component";
import { AuthGuard } from "src/app/core/guard/utility.guard";
import { ReportsComponent } from "./reports/reports.component";

import { AssetManagementDashboardDataResolver } from "src/app/core/resolvers/asset-management/dashboard-data.resolver";
import { pendingChangesGuard } from "src/app/core/guard/pending-changes.guard";

import { AssetsViewComponent } from "./assets-view/assets-view.component";
import { SystemAssetsVerificationViewComponent } from "./assets-view/system-assets-verification-view/system-assets-verification-view.component";


export const assetManagementRoutes: Routes = [
  {
    path: 'asset-management/auth-tools',

    component: AssetManagementAuthoringToolsComponent,
    canActivate: [AuthGuard, pendingChangesGuard],
    canActivateChild: [AuthGuard],
    children: [

      {
        path: '',
        component: AssetManagementDashboardComponent,
        resolve: { dashboard: AssetManagementDashboardDataResolver }
      },

      { path: 'asset-management-reports', component: ReportsComponent },

            //**************Assets View*********************/
      { path: 'assets-view', component: AssetsViewComponent },
      { path: 'assets-view/system-assets-verification-view', component: SystemAssetsVerificationViewComponent },


      //**************Shared Workflows*********************/
      {
        path: 'system-asset-capture',
        loadChildren: () =>
          import(
            '../shared-workflows/system-asset-capture/system-asset-capture.module'
          ).then(m => m.SystemAssetCaptureModule)
      },
      {
        path: 'data-asset-capture',
        loadChildren: () =>
          import(
            '../shared-workflows/data-asset-capture/data-asset-capture.module'
          ).then(m => m.DataAssetCaptureModule)
      },
      {
        path: 'data-asset-configuration',
        loadChildren: () =>
          import(
            '../shared-workflows/data-asset-configuraion/data-asset-configuration.module'
          ).then(m => m.DataAssetConfigurationModule)
      },


    ],


  },


  //  {path: 'asset-management/auth-tools', component: AssetManagementAuthoringToolsComponent, 
  // resolve: { dashboard: AssetManagementDashboardDataResolver },canActivate:[AuthGuard]}, 


];

export const assetManagementRouter = RouterModule.forChild(assetManagementRoutes);


